// flow weak

import React, {
  PureComponent
}                             from 'react';
import PropTypes              from 'prop-types';
import AnimatedView           from '../../../../components';
import styles                 from './style'
import {
  defaultOptions,
  checkStatus,
  parseJSON,
  getLocationOrigin
}                     from '../../../../services/fetchTools';
import { withRouter } from 'react-router';
import DatePicker from 'react-datepicker';
import moment from 'moment';


class HostGame extends PureComponent {
  static propTypes = {
    actions: PropTypes.shape({
      enterPage: PropTypes.func,
      leavePage: PropTypes.func,
    })
  };

  constructor(props) {
    super(props);
    this.state = {
      selected_one: {
        venue: '',
        game_type: '',
        date: moment(),
        start_time: '',
        end_time: '',
        price: 200,
        batch_size: 14,
      },
      venues: [],
      game_types: [],
      data_uploaded: false,
      data_error: false,
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleDate = this.handleDate.bind(this);

  }


  componentDidMount() {
    this.getFixtureList();
  }

  getFixtureList() {
     const url = `${getLocationOrigin()}/eagleeye/get_details_for_fixture_creation/`;
     const options = {...defaultOptions};

     fetch(url, options)
       .then(checkStatus)
       .then(parseJSON)
       .then(data => this.setState({ venues: data.venues, game_types: data.game_type }))
       .catch(error => error);
  }

  postCreateGame(data, props) {
    const url = `${getLocationOrigin()}/eagleeye/host_a_game/`;
    const options = {...defaultOptions};
    var venue = data.venue
    var game_type = data.game_type
    if(!data.venue){venue=this.state.venues[0].id}
    if(!data.game_type){game_type=this.state.game_types[0].pk}
    options['method'] = 'post';
    options['headers'] = {'content-type': 'application/json'}
    options['body'] = JSON.stringify({
                        'venue_id': venue,
                        'game_type_id': game_type,
                        'start_time': data.start_time,
                        'end_time': data.end_time,
                        'price': data.price,
                        'date': data.date,
                        'batch_size': data.batch_size
                      });
    console.log('Going to fetch');
    return fetch(url, options)
      .then(checkStatus)
      .then(parseJSON)
      .then(function(response){                      // first then()
          alert(response.message);
          props.history.goBack();
        })
      .catch(error => {
        console.log(error);
        alert(error.message);
      });
  }

  handleDate(date){
    var new_selected_one =  Object.assign({}, this.state.selected_one);
    new_selected_one['date'] = date
    this.setState({selected_one: new_selected_one});
  }

  handleChange(event) {
    const name = event.target.name;
    var new_selected_one =  Object.assign({}, this.state.selected_one);
    new_selected_one[name] = event.target.value
    this.setState({selected_one: new_selected_one});
  }

  handleSubmit(event) {
    event.preventDefault();
    this.postCreateGame(this.state.selected_one, this.props);
    console.log('post');
    console.log(this.state);
  }

  render() {
    console.log(this.state.selected_one);
    console.log('sucess');
    console.log(this.state);
    return(
      <div style={styles.container}>
        <div className="row col-md-8 table-bordered" style={styles.table}>
          <div style={styles.main_header} className="col-md-12">
            <h3 style={{textAlign:'center'}}>Host a Game</h3>
          </div>
          <form  className="validated-form form-horizontal" onSubmit={this.handleSubmit}>

            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Date
              </div>
              <DatePicker selected={this.state.selected_one.date} onChange={this.handleDate}/>
            </div>

            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Venue
              </div>
              <select name="venue" className="col-md-6" style={styles.item_body} value={this.state.value}
                onChange={this.handleChange}>
                {
                  this.state.venues.map((x, index) => (
                  <option key={x.id} value={x.id}>{x.name}</option>
                  ))
                }
              </select>
            </div>

            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Game type
              </div>
              <select name="game_type" style={styles.item_body} className="col-md-6" value={this.state.value} onChange={this.handleChange}>
                {
                  this.state.game_types.map((x, index) => (
                  <option key={x.pk} value={x.pk}>{x.game + ' ' + x.name}</option>
                  ))
                }
              </select>
            </div>

            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Start Time
              </div>
              <input type="text" style={styles.input} className="required" name="start_time" value={this.state.value}
                onChange={this.handleChange} placeholder="19:30:00"/>
            </div>

            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                End Time
              </div>
              <input type="text" style={styles.input} name="end_time" className="required" value={this.state.value}
                onChange={this.handleChange} placeholder="20:30:00"/>
            </div>

            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Batch Size
              </div>
              <input type="number" style={styles.input} name="batch_size" className="required"
                value={this.state.selected_one.batch_size} onChange={this.handleChange}/>
            </div>

            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Per Session Price
              </div>
              <input type="number" style={styles.input} name="price" className="required"
                value={this.state.selected_one.price} onChange={this.handleChange}/>
            </div>

            <div style={styles.button_submit} className="col-md-12">
              <input className="btn btn-lg" type="submit" value="Submit" style={{backgroundColor:'#302C35',
                color:'#ffffff'}}/>
            </div>
            <div className="col-md-12">
              {this.state.data_uploaded?<div className="text-success" style={styles.success}>* Fixture created successfully.</div>:''}
              {this.state.data_error?<div className="text-danger" style={styles.success}>* Error, creation failed.</div>:''}
            </div>
          </form>
        </div>
      </div>
    );
  }
}

export default HostGame;



// WEBPACK FOOTER //
// ./src/app/views/partner/crud/hostGame/index.js